import { useEffect, useRef } from "react";

export function FlowProfileCanvas({ stenosis }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const gl = canvas.getContext("webgl");

    if (!gl) return;

    gl.viewport(0, 0, canvas.width, canvas.height);

    const vertexSrc = `
      attribute vec2 position;
      void main() {
        gl_Position = vec4(position, 0.0, 1.0);
      }
    `;

    const fragmentSrc = `
      precision mediump float;
      uniform float stenosis;

      void main() {
        float x = gl_FragCoord.x / 300.0;
        float flow = exp(-stenosis * 4.0 * abs(x - 0.5));
        gl_FragColor = vec4(1.0 - flow, flow, 0.0, 1.0);
      }
    `;

    function compileShader(type, source) {
      const shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      return shader;
    }

    const program = gl.createProgram();
    gl.attachShader(program, compileShader(gl.VERTEX_SHADER, vertexSrc));
    gl.attachShader(program, compileShader(gl.FRAGMENT_SHADER, fragmentSrc));
    gl.linkProgram(program);
    gl.useProgram(program);

    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]),
      gl.STATIC_DRAW
    );

    const positionLoc = gl.getAttribLocation(program, "position");
    gl.enableVertexAttribArray(positionLoc);
    gl.vertexAttribPointer(positionLoc, 2, gl.FLOAT, false, 0, 0);

    gl.uniform1f(
      gl.getUniformLocation(program, "stenosis"),
      stenosis
    );

    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  }, [stenosis]);

  return <canvas ref={canvasRef} width={300} height={100} />;
}
